import { PURCHASE_TYPE } from "../domain/purchase";
import routes from "../routes";
import { toLoginUrl } from "../routing-utils";

export const savePriceItem = ({ seats, price }) => (
	{ storageService, authService, routingService },
	{ planCode, planID },
) => {
	storageService.priceItem.write({
		seats,
		price,
		planCode,
		planID,
		purchaseType: PURCHASE_TYPE.SUBSCRIPTION,
	});

	routingService.push(
		authService.isAuthorized()
			? routes.purchase.billing
			: toLoginUrl({ returnUrl: routes.purchase.billing }),
	);
};
